import React, { useState, useEffect, useMemo } from 'react';
import * as R from 'ramda';
import { composePS } from '@cd/pipe';
import { useHistory, useLocation } from 'react-router';
import styles from '../css/Register.module.scss';
import { postJSONPS } from '../../lib/utils/fetch';
import { either } from '../../lib/utils/utils';
import Form from '../../dynamic/components/form/components/Form';
import { SECURITY_Q_FORM } from '../../lib/utils/formFields';
import { useForm } from '../../dynamic/components/form/components/formUtils';
import withAlert from './withAlert';

const postSetSecurityInfo = data =>
	composePS(postJSONPS)('POST', `/setSecurityQuestions`, {
		body: JSON.stringify({ data })
	});

const RecoverPassword = withAlert(({ onOpenAlertDlg }) => {
	const history = useHistory();
	const location = useLocation();
	const {
		data,
		onUpdateData,
		showPassword,
		onShowPassword,
		onSave: formOnSave,
		touched,
		validation,
		updateInitData
	} = useForm({ joiValidationSchema: SECURITY_Q_FORM });
	const [fieldData, setFieldData] = useState({});

	useEffect(() => {
		const { data: secData, bookNo, email } = location.state;
		updateInitData({
			email,
			bookNo,
			answer1: '',
			answer2: '',
			password: ''
		});
		setFieldData(secData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onBackToRecover = () => {
		history.push('/forgotPassword');
	};

	const onSave = () => {
		postSetSecurityInfo(data).then(
			either(
				e =>
					onOpenAlertDlg({
						message: R.is(String, e) ? e : JSON.stringify(e),
						title: 'Error'
					}),
				message => {
					formOnSave();
					onOpenAlertDlg({
						message,
						title: 'Success',
						okCallback: () => {
							history.push('/login');
						}
					});
				}
			)
		);
	};

	const formFields = useMemo(
		() =>
			R.map(
				({ name, ...other }) =>
					name === 'answer1'
						? { name, ...other, label: fieldData.Question_One }
						: name === 'answer2'
						? { name, ...other, label: fieldData.Question_Two }
						: { name, ...other },
				SECURITY_Q_FORM
			),
		[fieldData]
	);

	return (
		<div className={styles.wrap} style={{ marginTop: '128px' }}>
			<Form
				alwaysTouched
				formTitle="ANSWER QUESTION/SET PASSWORD"
				formFields={formFields}
				data={data}
				onUpdateData={onUpdateData}
				showPassword={showPassword}
				onShowPassword={onShowPassword}
				onSave={onSave}
				onCancel={onBackToRecover}
				validation={validation}
				editing={true}
				touched={touched}
				buttonLabels={['RESET PASSWORD', 'RECOVERY']}
				buttonIcons={['lock', 'keyboard_backspace']}
			/>
		</div>
	);
});

export default RecoverPassword;
